import template from './help-button.html';
import controller from './help-button.controller';

let HelpButtonComponent = {
  restrict: 'E',
  bindings: {
    topic: '@',
    label: '@',
    size: '@',
    browse: '@'
  },
  template,
  controller
};

export default HelpButtonComponent;



// WEBPACK FOOTER //
// ./client/help/help-button/help-button.component.js